import React from 'react'
import { createEventObjectForWeekView } from '../calendarFunctions'
import {endOfWeek, startOfWeek, eachDayOfInterval, format} from 'date-fns'
import InternalCalendarMenu from '../InternalCalendarMenu/InternalCalendarMenu'
import SmallWeekViewCalendar from './SmallWeekViewCalendar'
import LargeWeekViewCalendar from './LargeWeekViewCalendar'

const toLocalDate = (value) => {
  if (value instanceof Date) return value
  const dateText = String(value || '').slice(0, 10)
  const match = dateText.match(/^(\d{4})-(\d{2})-(\d{2})$/)
  if (match) return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]))
  return new Date(value)
}

const WeekViewCalendar = (props) => {
  const container = React.useRef(null)
  const containerNav = React.useRef(null)
  const containerOffset = React.useRef(null)
  const [firstDayOfWeek, setFirstDayOfWeek] = React.useState(startOfWeek(toLocalDate(props.selectedDay.date)))
  const [lastDayOfWeek, setLastDayOfWeek] = React.useState(endOfWeek(toLocalDate(props.selectedDay.date)))
  const [displayedWeek, setDisplayedWeek] = React.useState(eachDayOfInterval({start: startOfWeek(toLocalDate(props.selectedDay.date)), end: endOfWeek(toLocalDate(props.selectedDay.date))}))
  const [weekViewEventObject, setWeekViewEventObject] = React.useState([])
  const [monthName, setMonthName] = React.useState(format(toLocalDate(props.selectedDay.date), 'MMMM yyyy'))

  React.useEffect(() => {
    // Set the container scroll position based on the current time.
    const currentMinute = new Date().getHours() * 60
    container.current.scrollTop = ((container.current.scrollHeight - containerNav.current.offsetHeight - containerOffset.current.offsetHeight) * currentMinute) / 1440
  }, [])

  React.useEffect(() => {
    (format(firstDayOfWeek, 'MMM') === format(lastDayOfWeek, 'MMM')) ? setMonthName(format(firstDayOfWeek, 'MMMM yyyy')) : setMonthName(`${format(firstDayOfWeek, 'MMM')}-${format(lastDayOfWeek, 'MMM yyyy')}`)
  }, [displayedWeek, firstDayOfWeek, lastDayOfWeek])

  React.useEffect(() => {
    const nextSelectedDate = toLocalDate(props.selectedDay.date)
    const nextWeekStart = startOfWeek(nextSelectedDate)
    const nextWeekEnd = endOfWeek(nextSelectedDate)
    setFirstDayOfWeek(nextWeekStart)
    setLastDayOfWeek(nextWeekEnd)
    setDisplayedWeek(eachDayOfInterval({start: nextWeekStart, end: nextWeekEnd}))
  }, [props.selectedDay.date])

  React.useEffect(() => createEventObjectForWeekView(displayedWeek, props.calendarDaysWithEvents, setWeekViewEventObject), [props.calendarDaysWithEvents, displayedWeek])

  return (
    <div className='calendar__week-view'>
      <div className="calendar__calendar-view-frame">
      <InternalCalendarMenu view={'Week view'} setView={props.setView} selectedDay={props.selectedDay} setSelectedDay={props.setSelectedDay} calendarDaysWithEvents={props.calendarDaysWithEvents} setFirstDayOfWeek={setFirstDayOfWeek} setLastDayOfWeek={setLastDayOfWeek} setDisplayedWeek={setDisplayedWeek} firstDayOfWeek={firstDayOfWeek} lastDayOfWeek={lastDayOfWeek} monthName={monthName} />
        <div ref={container} className="calendar__week-grid isolate flex flex-auto flex-col border border-solid border-gray-300 overflow-auto">
          <div style={{ width: '165%' }} className="flex max-w-full flex-none flex-col sm:max-w-none md:max-w-full">
            <SmallWeekViewCalendar displayedWeek={displayedWeek} setSelectedDay={props.setSelectedDay} setView={props.setView} containerNav={containerNav} />
            <LargeWeekViewCalendar containerOffset={containerOffset} displayedWeek={displayedWeek} weekViewEventObject={weekViewEventObject} setEditEvent={props.setEditEvent} setEventToEdit={props.setEventToEdit} createNewCalendarEvent={props.createNewCalendarEvent} schoolCalendar={props.schoolCalendar} />
          </div>
        </div>
      </div>
    </div>
  )
}
export default WeekViewCalendar
